import {ToggleItem, KeyboardNav} from 'omni-toggle';

App.registerBehavior('MainMenu', function (appSettings) {
  document.querySelectorAll('.main-menu').forEach(menu => {
    const isAriaWidget = menu.hasAttribute('role');
    const menuNav = new KeyboardNav(menu, {
      items: `:scope > .main-menu__item > .main-menu__item-header .main-menu__item-link,
          :scope > .main-menu__item > .main-menu__item-header .main-menu__item-toggle`,
      orientation: '--nav-orientation',
      aria: isAriaWidget,
      tabAccess: isAriaWidget ? 'active' : 'all',
    });
    if (isAriaWidget && ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        const newOrientation = menuNav.updateOrientationAttribute();
        if (newOrientation) {
          menu.setAttribute('role', newOrientation === 'horizontal' ? 'menubar' : 'menu');
        }
      });
      resizeObserver.observe(document.body);
    }

    menu.querySelectorAll('.main-menu__item--expanded').forEach(subMenuItem => {
      const subMenu = subMenuItem.querySelector(':scope > .main-menu__sub-menu');
      const subMenuToggle = new ToggleItem(subMenu, {
        hover: subMenuItem,
        touchHover: subMenuItem.querySelector(':scope > .main-menu__item-header .main-menu__item-link'),
        button: subMenuItem.querySelector(':scope > .main-menu__item-header .main-menu__item-toggle'),
        buttonActiveClass: 'icon-button--rotate', //'icon--rotate',
        deactivateOnBlur: true,
      });
      const subMenuNav = new KeyboardNav(subMenu, {
        items: ':scope > .main-menu__item > .main-menu__item-header .main-menu__item-link',
        orientation: 'vertical',
        aria: isAriaWidget,
        tabAccess: isAriaWidget ? 'none' : 'all'
      });

      subMenuToggle.getButton().addEventListener('keydown', e => {
        switch (e.key) {
          case 'Enter':
          case 'Space':
          case menuNav.getCrossNextKey():
            subMenuToggle.activate();
            subMenuNav.focusFirst();
            e.preventDefault();
            e.stopPropagation();
        }
      });
    });
  });
});